function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { changePassword, closeModal, getFullUserDetails, editBillingDetails } from "@common/actions";
import Spinner from "@common/components/Spinner";
import PostLoginBillingForm from "@common/components/authentication/PostLoginBillingForm";
import PostLoginChangePassword from "@common/components/authentication/PostLoginChangePassword";
import PaymentMethod from "@common/components/payment/PaymentMethod";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import { Component, PureComponent, createRef } from "react";
import { connect } from "react-redux";
import { isBillingValid } from "@common/utils/helpers";
import { isEmpty } from "lodash";
import { BILLING_FORM_TYPE, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR } from "@config/constants";
var renderTitle = function(title, subtitle) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "multi-modal-title",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                children: title
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: subtitle
            })
        ]
    });
};
var PostLoginMultiModal = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(PostLoginMultiModal, PureComponent);
    var _super = _create_super(PostLoginMultiModal);
    function PostLoginMultiModal(props) {
        _class_call_check(this, PostLoginMultiModal);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "handleConfirm", /*#__PURE__*/ _async_to_generator(function() {
            var _this_props, _$editBillingDetails, authentication, userDetails, _this_changePasswordRef_current, data, error, userDetails1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_props = _this1.props, _$editBillingDetails = _this_props.editBillingDetails, authentication = _this_props.authentication, userDetails = _this_props.userDetails;
                        if (_this1.props.forceShow && !isEmpty(userDetails.paymentMethod) && !isBillingValid(userDetails.billingAddress)) {
                            _this1.setState({
                                onlyBillingShown: true
                            });
                        }
                        _this1.setState({
                            confirmPending: true
                        });
                        if (!_this1.changePasswordRef.current) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (_this_changePasswordRef_current = _this1.changePasswordRef.current) === null || _this_changePasswordRef_current === void 0 ? void 0 : _this_changePasswordRef_current.changePassword()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        _this1.validateForms(true);
                        if (!(userDetails.cf_req_payment === true && !isEmpty(userDetails.paymentMethod))) return [
                            3,
                            6
                        ];
                        data = {
                            token: authentication.token,
                            cf_req_payment: false
                        };
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            _$editBillingDetails(data)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            4,
                            _this1.props.getFullUserDetails()
                        ];
                    case 7:
                        _state.sent();
                        _this1.setState({
                            confirmPending: false
                        });
                        if (!_this1.props.forceShow) return [
                            3,
                            10
                        ];
                        userDetails1 = _this1.props.userDetails;
                        if (!isEmpty(userDetails1.paymentMethod)) {
                            _this1.setState({
                                shouldRenderPayment: false
                            });
                        } else {
                            _this1.props.enqueueSnackbar(_this1.props.i18n.errors.missingPayment, {
                                variant: SNACKBAR_VARIANT_ERROR,
                                autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                            });
                        }
                        if (isBillingValid(userDetails1.billingAddress)) {
                            _this1.setState({
                                shouldRenderBilling: false
                            });
                        }
                        if (!(!isEmpty(userDetails1.paymentMethod) && isBillingValid(userDetails1.billingAddress))) return [
                            3,
                            10
                        ];
                        if (!_this1.props.onSuccess) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            _this1.props.onSuccess()
                        ];
                    case 8:
                        _state.sent();
                        _state.label = 9;
                    case 9:
                        _this1.closeModal();
                        _state.label = 10;
                    case 10:
                        return [
                            2
                        ];
                }
            });
        }));
        var forceShow = props.forceShow;
        var _props_userDetails = props.userDetails, cf_req_payment = _props_userDetails.cf_req_payment, cf_req_billing = _props_userDetails.cf_req_billing, cf_req_password = _props_userDetails.cf_req_password;
        var _props_userDetails1 = props.userDetails, billingAddress = _props_userDetails1.billingAddress, paymentMethod = _props_userDetails1.paymentMethod;
        _this.state = {
            show: true,
            shouldToggleWithTransition: false,
            isEditBillingOpen: true,
            billingWillUnmount: false,
            shouldSubmitForm: false,
            validateForms: false,
            userLoading: [],
            isBillingFormValid: false,
            shouldRenderPayment: forceShow ? isEmpty(paymentMethod) : cf_req_payment,
            shouldRenderBilling: forceShow ? !isBillingValid(billingAddress) : cf_req_billing,
            shouldRenderPassword: cf_req_password,
            confirmPending: false,
            onlyBillingShown: false
        };
        _this.changePasswordRef = /*#__PURE__*/ createRef();
        _this.handleConfirm = _this.handleConfirm.bind(_assert_this_initialized(_this));
        _this.validateForms = _this.validateForms.bind(_assert_this_initialized(_this));
        _this.setFormValidity = _this.setFormValidity.bind(_assert_this_initialized(_this));
        _this.allowFormSubmit = _this.allowFormSubmit.bind(_assert_this_initialized(_this));
        _this.setUserLoad = _this.setUserLoad.bind(_assert_this_initialized(_this));
        _this.callbackOnSuccessfulAddressChange = _this.callbackOnSuccessfulAddressChange.bind(_assert_this_initialized(_this));
        _this.closeModal = _this.closeModal.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(PostLoginMultiModal, [
        {
            key: "validateForms",
            value: function validateForms(validateForms) {
                this.setState({
                    validateForms: validateForms
                });
            }
        },
        {
            key: "setFormValidity",
            value: function setFormValidity(isValid) {
                this.setState({
                    validateForms: isValid
                });
            }
        },
        {
            key: "allowFormSubmit",
            value: function allowFormSubmit(shouldSubmitForm) {
                this.setState({
                    shouldSubmitForm: shouldSubmitForm
                });
            }
        },
        {
            key: "callbackOnSuccessfulAddressChange",
            value: function callbackOnSuccessfulAddressChange() {
                this.setUserLoad(false);
            }
        },
        {
            key: "setUserLoad",
            value: function setUserLoad(isLoading) {
                var _this = this;
                this.setState(function(prevState) {
                    var elements = _to_consumable_array(prevState.userLoading);
                    if (isLoading) {
                    // elements.push(isLoading);
                    } else {
                        elements.pop();
                        if (_this.props.order && typeof _this.props.order.toggleLoading === "function" && elements.length === 0) {
                            _this.props.order.toggleLoading(false);
                        }
                    }
                    return {
                        userLoading: _to_consumable_array(elements)
                    };
                });
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                if (this.props.setPostLoginModalOpened) {
                    this.props.setPostLoginModalOpened(false);
                }
                if (this.props.setForceShowMissingInfo) {
                    this.props.setForceShowMissingInfo(false);
                }
                this.props.closeModal();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, order = _this_props.order, forceShow = _this_props.forceShow;
                var _this_state = this.state, shouldSubmitForm = _this_state.shouldSubmitForm, userLoading = _this_state.userLoading;
                var validateForms = this.state.validateForms;
                var billingAddress = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.billingAddress) ? userDetails.billingAddress : {};
                var commonEditFormProps = {
                    shouldToggleWithTransition: false,
                    isEditDeliveryOpen: false,
                    isEditBillingOpen: true,
                    sameAddress: false,
                    userLoading: userLoading,
                    i18n: i18n,
                    validateForms: validateForms,
                    shouldSubmitForm: shouldSubmitForm,
                    setUserLoad: this.setUserLoad,
                    setFormValidity: this.setFormValidity,
                    allowFormSubmit: this.allowFormSubmit,
                    callbackOnSuccessfulAddressChange: this.callbackOnSuccessfulAddressChange
                };
                var componentMap = {
                    PostLoginChangePassword: {
                        component: PostLoginChangePassword,
                        componentName: "PostLoginChangePassword",
                        parentComponent: null,
                        parentComponentName: null,
                        parentProps: {
                            enterFromLeft: true,
                            onlyChnagePassowrd: false,
                            shouldToggleWithTransition: true
                        }
                    }
                };
                var _this_props_userDetails = this.props.userDetails, cf_req_billing = _this_props_userDetails.cf_req_billing, cf_req_password = _this_props_userDetails.cf_req_password, cf_req_payment = _this_props_userDetails.cf_req_payment;
                var shouldClose = cf_req_billing === false && cf_req_password === false && cf_req_payment === false && !forceShow;
                var _userDetails_paymentMethod, _this_props_confirmButtonText;
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: this.state.show && !shouldClose && /*#__PURE__*/ _jsxs("div", {
                        className: "modal post-login-modal",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "post-login-header",
                                children: renderTitle("ЛИПСВАЩА ИНФОРМАЦИЯ", "Необходима е, за да продължите да използвате услугата")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "post-login-content",
                                children: [
                                    this.state.shouldRenderPayment && /*#__PURE__*/ _jsxs("div", {
                                        className: "content-payment",
                                        children: [
                                            renderTitle("Платежен метод", "Въведете банкова карта или PayPal акаунт, за да избегнете прекъсване на услугата"),
                                            /*#__PURE__*/ _jsx(PaymentMethod, {
                                                paymentMethod: (_userDetails_paymentMethod = userDetails.paymentMethod) !== null && _userDetails_paymentMethod !== void 0 ? _userDetails_paymentMethod : []
                                            })
                                        ]
                                    }),
                                    this.state.shouldRenderBilling && /*#__PURE__*/ _jsxs("div", {
                                        className: "content-billing",
                                        children: [
                                            renderTitle("Адрес за фактуриране", "Въведете адрес за фактуриране, за да продължи вашият предплатен абонаментен план и след изтичане на периода"),
                                            /*#__PURE__*/ _jsx(PostLoginBillingForm, _object_spread({
                                                classes: "missing-info-billing",
                                                title: i18n.account.invoiceInformation,
                                                subTitle: i18n.account.invoiceInformationDesc,
                                                address: billingAddress,
                                                order: order,
                                                sameAddress: false,
                                                isDeliveryAddressForm: false,
                                                willComponentUnmount: false
                                            }, commonEditFormProps))
                                        ]
                                    }),
                                    this.state.shouldRenderPassword && /*#__PURE__*/ _jsxs("div", {
                                        className: "content-password",
                                        children: [
                                            renderTitle("Промяна на парола", "Въведете нова парола"),
                                            /*#__PURE__*/ _jsx(PostLoginChangePassword, {
                                                ref: this.changePasswordRef,
                                                i18n: i18n,
                                                componentMap: componentMap,
                                                componentName: "PostLoginChangePassword",
                                                changePassword: this.props.changePassword,
                                                enqueueSnackbar: this.props.enqueueSnackbar
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "post-login-footer",
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        color: "primary",
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        onClick: function() {
                                            sessionStorage.setItem("missing-info", true);
                                            _this.closeModal();
                                        },
                                        className: " postpone-button ",
                                        disabled: this.state.confirmPending,
                                        children: "По-късно"
                                    }),
                                    /*#__PURE__*/ _jsxs(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        className: "button raised half-width pointer confirm-button",
                                        onClick: this.handleConfirm,
                                        disabled: this.state.confirmPending,
                                        children: [
                                            this.state.confirmPending && /*#__PURE__*/ _jsx(Spinner, {}),
                                            !this.state.confirmPending && ((_this_props_confirmButtonText = this.props.confirmButtonText) !== null && _this_props_confirmButtonText !== void 0 ? _this_props_confirmButtonText : "Потвърди")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var userDetails = this.props.userDetails;
                var _this_props_userDetails = this.props.userDetails, cf_req_payment = _this_props_userDetails.cf_req_payment, cf_req_billing = _this_props_userDetails.cf_req_billing, cf_req_password = _this_props_userDetails.cf_req_password;
                var shouldClose = cf_req_payment === false && cf_req_billing === false && cf_req_password === false;
                if (this.props.forceShow && !isEmpty(userDetails.paymentMethod) && isBillingValid(userDetails.billingAddress) && this.state.onlyBillingShown) {
                    this.closeModal();
                } else if (!this.props.forceShow && shouldClose) {
                    this.closeModal();
                }
            }
        }
    ]);
    return PostLoginMultiModal;
}(PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails, order = param.order, authentication = param.authentication, history = param.history;
    return {
        userDetails: userDetails,
        i18n: i18n,
        order: order,
        authentication: authentication,
        history: history
    };
};
export default withSnackbar(connect(mapStateToProps, {
    changePassword: changePassword,
    closeModal: closeModal,
    getFullUserDetails: getFullUserDetails,
    editBillingDetails: editBillingDetails
})(PostLoginMultiModal));
